<template>
	<section class="lang_switcher" :class="{ var_is_open: isOpen }" @click.stop="isOpen = !isOpen">
		<IconGlobe />
		<ul :class="{ var_is_open: isOpen }">
			<li
				v-for="lang in pageLang"
				:class="{ is_active: current === lang.code }"
				:key="lang.id"
				@mouseenter="onMouseEnter"
				@mouseleave="onMouseLeave"
			>
				<router-link :to="lang.url | clearUrl" :class="{ is_active: current === lang.code }">
					{{ lang.native_name }}
				</router-link>
			</li>
		</ul>
		<span class="dropdown"></span>
	</section>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import EventBus from "@/helpers/event-bus";
import IconGlobe from "@/components/icons/IconGlobe";
import PointerHoverMixin from "@/mixins/pointerHover";

export default {
	name: "LanguageSwitcher",
	mixins: [PointerHoverMixin],
	components: {
		IconGlobe,
	},
	data() {
		return {
			isOpen: false,
		};
	},
	mounted() {
		this.addLinksListener();
	},
	updated() {
		this.addLinksListener();
	},
	computed: {
		...mapState({
			languages: (state) => Object.values(state.site.langs),
			current: (state) => state.site.currentLanguage,
			...mapGetters("page", ["currentPage"]),
		}),
		pageLang() {
			if (!this.currentPage || !this.currentPage.langs) {
				return this.languages;
			}

			const keys = Object.keys(this.currentPage.langs);

			if (keys.length) {
				return this.languages.map((lang) => {
					const pageLangUrl = this.currentPage.langs[lang.code];

					if (pageLangUrl) {
						return { ...lang, url: pageLangUrl };
					}

					return { ...lang };
				});
			}

			// if (this.currentPage && this.currentPage?.langs?.length) {
			// console.log('length', this.currentPage?.langs);
			// }
			// if (this.currentPage && keys.length) {
			// 	return this.languages.map(lang => {
			// 		const pageLangUrl = this.page.langs[lang];

			// 		if (pageLangUrl) {
			// 			return {...lang, url: pageLangUrl}
			// 		}

			// 		return {...lang}
			// 	})
			// }

			return this.languages;
		},
	},
	methods: {
		onMouseEnter(ev) {
			EventBus.$emit("movePointer", {
				width: ev.target.clientWidth,
				height: ev.target.clientHeight,
			});
		},
		onMouseLeave() {
			EventBus.$emit("stopPointer");
		},
	},
	// watch: {
	// 	page: {
	// 		handler:function(newVal) {
	// 			console.log("new Value is " + newVal)
	// 		},
	// 		deep:true
	// 	}
	// }
};
</script>

<style lang="scss" scoped>
.lang_switcher {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 9;
	background: #fff;
	display: flex;
	border-radius: 0 0 14px 0 / 0 0 9px 0;
	transition: background-color 0.3s;

	.var_page_advice & {
		display: none;
	}

	&:hover:not(.var_is_open) {
		background: $colorBeige2;
		cursor: pointer;
	}

	&.var_is_open {
		.dropdown {
			transform: translate(0, 3px) rotate(135deg);
		}
	}

	.dropdown {
		display: block;
		width: 7px;
		height: 7px;
		border-bottom: 2px solid #000;
		border-left: 2px solid #000;
		border-radius: 0 0 0 2px;
		margin: 10px 12px 0 0;
		transform: rotate(-45deg);
		cursor: pointer;
	}

	svg {
		margin: 9px 0 0 10px;
	}

	@include mq($from: xl) {
		flex: 0 0 100%;
	}
}

ul {
	list-style: none;
	padding: 0;
	display: flex;
	flex-direction: column;
	margin: 0;
	padding: 0;
	transition: opacity 0.3s, visibility 0s ease 0s;
	overflow: hidden;
	max-height: 32px;
	transition: max-height 0.3s;

	&.var_is_open {
		max-height: 128px;
	}

	.var_page_advice & {
		visibility: hidden;
		opacity: 0;
		transition: opacity 0.3s, visibility 0s ease 0.3s;
	}

	li {
		padding: 0 5px;
		order: 2;

		&.is_active {
			order: 1;
		}

		@include mq($from: m) {
			padding: 0 5px;

			&:first-child {
				margin-top: 0;
			}
		}
	}

	a {
		font-family: $fontRubik;
		line-height: 1.55;
		font-size: 12px;
		text-transform: uppercase;
		display: inline-block;
		position: relative;
		transition: color 0.3s;
		color: #000 !important;
		padding: 7px 0;

		&.is_active {
			text-decoration: none;
		}

		&:not(.is_active):hover {
			color: $colorRed1 !important;
		}
	}
}
</style>
